import { render } from "./QuestionnaireSelect.vue?vue&type=template&id=4cb8665a"
import script from "./QuestionnaireSelect.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireSelect.vue?vue&type=script&lang=ts"

import "./QuestionnaireSelect.vue?vue&type=style&index=0&id=4cb8665a&lang=scss"
script.render = render

export default script